import mutations from './filter-mutations'
import actions from './filter-actions'

export default {
  namespaced: true,
  state: {
    activeCardsNumber: 0,
    activePrimaryFilters: [],
    activeVariant: {},
    currentSorting: 'featured',
    activeSubPage: { title: '', description: '' },
    allFilters: [],
    appIsInitialized: false,
    basePath: '',
    cards: [],
    cardsFiltered: [],
    cardsFilteredWithPromos: [],
    cardsFilteredDisplayed: [],
    currentBreakpoint: {},
    currentUrl: '',
    globalFilterReset: false,
    globalFilterStateUpdate: false,
    hiddenSecondaries: [],
    initialSecondaryFilterSetup: true,
    isMobile: false,
    itemFilters: {
      selected: {},
      results: {},
    },
    filterOverlayIsOpen: false,
    noResults: false,
    pageviewsAreTracked: false,
    pathFilters: [],
    preferredCardSummary: {}, // #DY-FILTER-PAGE-SHORT-PRODUCT-DESCRIPTION
    primaryFilters: [],
    promoCards: [],
    queryFilters: [],
    resultsNumberHistory: [0],
    secondaryFilters: [],
    selectedCard: {},
    selectedCardIndex: -1,
    sortingOverlayIsOpen: false,
    subPages: [],
    tags: [],
    unselectedFilter: {},
    variantFilters: {
      selected: {},
      results: {},
    },
    variantNumberHistory: [],
  },

  mutations: mutations,

  actions: actions,

  getters: {
    activeCardsNumber: state => state.activeCardsNumber,
    activePrimaryFilters: state => state.activePrimaryFilters,
    activeSubPage: state => state.activeSubPage,
    activeVariant: state => state.activeVariant,
    appIsInitialized: state => state.appIsInitialized,
    basePath: state => state.basePath,
    cardsFiltered: state => state.cardsFiltered,
    cardsFilteredDisplayed: state => state.cardsFilteredDisplayed,
    cardsFilteredWithPromos: state => state.cardsFilteredWithPromos,
    currentBreakpoint: state => state.currentBreakpoint,
    currentSorting: state => state.currentSorting,
    currentUrl: state => state.currentUrl,
    filterOverlayIsOpen: state => state.filterOverlayIsOpen,
    globalFilterReset: state => state.globalFilterReset,
    globalFilterStateUpdate: state => state.globalFilterStateUpdate,
    hiddenSecondaries: state => state.hiddenSecondaries,
    initialSecondaryFilterSetup: state => state.initialSecondaryFilterSetup,
    isMobile: state => state.isMobile,
    itemFilters: state => state.itemFilters,
    primaryFilters: state => state.primaryFilters,
    resultsNumberHistory: state => state.resultsNumberHistory,
    sizeOverlayIsOpen: state => state.sizeOverlayIsOpen,
    sortingOverlayIsOpen: state => state.sortingOverlayIsOpen,
    tags: state => state.tags,
    unselectedFilter: state => state.unselectedFilter,
    variantFilters: state => state.variantFilters,
  },
}
